module.exports = __webpack_public_path__ + "static/media/strapColl.cf2e64f3.png";